import React from "react";

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void | Promise<void>;
  "data-testid"?: string;
}

export function Card({
  children,
  className = "",
  onClick,
  "data-testid": dataTestId,
}: CardProps) {
  return (
    <div
      className={`bg-duvi-elevated border border-duvi-border rounded-[8px] ${onClick ? "cursor-pointer" : ""} ${className}`}
      style={{ boxShadow: "var(--shadow-card)" }}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export function CardHeader({ children, className = "" }: CardHeaderProps) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export function CardTitle({ children, className = "" }: CardTitleProps) {
  return (
    <h4
      className={`text-duvi-text-primary ${className}`}
      style={{
        fontSize: "var(--text-lg)",
        fontWeight: "var(--font-weight-semibold)",
        lineHeight: "var(--line-height-heading)",
      }}
    >
      {children}
    </h4>
  );
}

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export function CardContent({ children, className = "" }: CardContentProps) {
  return <div className={`px-6 pb-6 ${className}`}>{children}</div>;
}
